import { j as e } from "../../../node_modules/react/jsx-runtime.js";
import { memo as S, useMemo as f } from "react";
import { clsx as h } from "../../../node_modules/clsx/dist/clsx.m.js";
import b from "../Icon/Icon.js";
import { Typography as z } from "../Typography/Typography.js";
import r from "./Avatar.module.scss.js";
import { AvatarStatus as C } from "./AvatarStatus/AvatarStatus.js";
const N = {
  xxl: "lg",
  xl: "md",
  l: "md",
  m: "sm"
}, A = S((u) => {
  const {
    type: c = "initials",
    size: t = "xl",
    imageSrc: o,
    imageAlt: a,
    avatarStatusType: l,
    iconName: i,
    color: n = "gray",
    onClick: m,
    testId: g,
    onError: s
  } = u, p = h(
    "border-solid border-2",
    r.avatarContainer,
    r[t],
    o ? r.gray : r[n],
    {
      "!cursor-default": !m
    }
  ), x = f(
    () => ({
      xs: "xxxs",
      sm: "xxs",
      m: "sm",
      l: "ml",
      xl: "xxl",
      xxl: "xxl"
    }),
    []
  ), v = f(() => {
    if (c === "icon" && i)
      return /* @__PURE__ */ e.jsx(
        b,
        {
          name: i,
          size: x[t]
        }
      );
    if (o && c !== "icon")
      return /* @__PURE__ */ e.jsx("div", { className: r.imageSrcContainer, children: /* @__PURE__ */ e.jsx(
        "img",
        {
          src: o,
          alt: a,
          onError: (d) => {
            d.currentTarget.src = "https://jisr-test-public.s3.me-south-1.amazonaws.com/images/employee.png", s == null || s(d);
          }
        }
      ) });
    const y = {
      xs: "interface/medium/xxs",
      sm: "interface/medium/xs",
      m: "interface/medium/s",
      l: "interface/medium/sm",
      xl: "interface/medium/m",
      xxl: "interface/medium/ml"
    }, j = {
      gray: "color/fg/bold",
      cyan: "color/fg/accent/cyan/default",
      orange: "color/fg/accent/orange/default",
      greenLight: "color/fg/accent/green/light/default",
      green: "color/fg/accent/green/default",
      red: "color/fg/accent/red/default",
      violet: "color/fg/accent/violet/default",
      pink: "color/fg/accent/pink/default"
    };
    return /* @__PURE__ */ e.jsx(
      z,
      {
        text: a == null ? void 0 : a.substring(0, 2).toUpperCase(),
        variant: y[t],
        textColor: j[n]
      }
    );
  }, [c, i, t, o, a, n, x, s]);
  return /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: p,
      ...m && {
        onClick: m,
        tabIndex: 0,
        role: "button"
      },
      "data-testid": g,
      children: [
        v,
        !!l && !["sm", "xs"].includes(t) && /* @__PURE__ */ e.jsx("div", { className: r.avatarStatus, children: /* @__PURE__ */ e.jsx(
          C,
          {
            avatarStatusType: l,
            size: N[t]
          }
        ) })
      ]
    }
  );
});
A.displayName = "Avatar";
export {
  A as Avatar,
  A as default
};
//# sourceMappingURL=Avatar.js.map
